import { render, staticRenderFns } from "./JobStatusChip.vue?vue&type=template&id=cfffe88c&scoped=true&"
import script from "./JobStatusChip.vue?vue&type=script&lang=js&"
export * from "./JobStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfffe88c",
  null
  
)

export default component.exports